export const imperialUnitsCountryCodes = [
  'en-US','es-US',
];

export const milesMultiplicator = 0.621371;
